


































import {
  defineComponent,
  computed,
} from '@vue/composition-api';

export default defineComponent({
  props: {
    todoItem: {
      type: Object,
      required: true,
    },
  },

  setup (props, { emit }) {
    const { todoItem } = props;

    const done = computed(() => todoItem.done);

    return {
      done,
      toggleTodo: () => {
        todoItem.done = !done.value;
      },
      deleteTodo: () => {
        emit('delete', todoItem);
      },
    };
  },
});
